export default __webpack_public_path__ + "static/TRCAUrban_Farm-9071f8e5cfb2d3541b6d5dfc8f7f7179.mp4";